import React from 'react';
const STATS = [{
  value: '17 años',
  label: 'De experiencia en el ecosistema Apple'
}, {
  value: '+8.500',
  label: 'Equipos Apple vendidos y configurados'
}, {
  value: '1 + 5',
  label: 'Libro principal y bonos incluidos'
}, {
  value: 'Todos',
  label: 'Los modelos con iOS actual'
}];
export function StatsBar() {
  return <section aria-label="Cifras principales" className="w-full border-y border-white/10 bg-gold px-5 py-8 sm:px-8" data-id="element-257" data-mp="1jbiws0f2lc81">
      <dl className="mx-auto grid w-full max-w-5xl gap-6 sm:grid-cols-2 lg:grid-cols-4" data-id="element-258" data-mp="1eeinzhqu5vd8">
        {STATS.map(stat => <div key={stat.value} className="text-center lg:text-left" data-id="element-259" data-mp="15kx8fw6uka2r">
            <dt className="text-2xl font-extrabold tracking-tight text-ink-950 sm:text-3xl" data-id="element-260" data-mp="15l5mvsimbng2">{stat.value}</dt>
            <dd className="mt-1 text-xs font-medium leading-relaxed text-ink-950/70 sm:text-sm" data-id="element-261" data-mp="10jq11y8m9cwm">{stat.label}</dd>
          </div>)}
      </dl>
    </section>;
}